<template>
    <div class="pago-externo">
      <h1>Procesando tu pago...</h1>
      <p>Por favor espera un momento.</p>
    </div>
  </template>
  
  <script>
  import Swal from 'sweetalert2';
  import axios from 'axios';
  export default {
    
    name: 'PagoExterno',
    data() {
        return {
            formData : {},
            order : {},
            jsonData: null,
            isProcessing : true,
            isRedirecting: false
        }
    },
    async mounted() {
        const referenceCode = this.$route.query.reference;
        this.loadJsonData(referenceCode);
    },
    methods : {
        async loadJsonData(reference) {
            try {
                const response = await axios.get(`https://zeb-api-prod.zebraasistencia.com/transacciones/${ reference }.json`);
                this.jsonData = response.data;
                try {
                    const { order, payment } = this.jsonData;
                    if (order && payment) {
                        this.order = order;
                        this.formData = payment;
                        this.procesarPago();
                    } else {
                        throw new Error('Datos incompletos en el archivo JSON');
                    }

                } catch (error) {
                    console.error('Error al procesar los datos:', error);
                }
            } catch (error) {
                console.error('Error cargando el JSON:', error);
                Swal.fire({
                    title: 'Error',
                    text: 'No se pudo cargar el archivo de pago. Verifica que exista y sea accesible.',
                    icon: 'error',
                    confirmButtonText: 'Ok'
                });
            }
        },
        async procesarPago(){
            try{
                const res = await this.$root.postTransaction(this.formData);
                if (res?.status === 'ERROR') {
                    Swal.fire({
                        title: 'Error',
                        text: res?.error?.message || 'Ocurrió un error en el pago.',
                        icon: 'error',
                        confirmButtonText: 'Ok'
                    });
                    this.isProcessing = false;
                } else {
                    this.monitorTransactionStatus?.(res.data?.data?.id);
                }

            } catch (error) {
                console.error('Error en la página de pago externo:', error);
                Swal.fire({
                    title: 'Error',
                    text: 'Ocurrió un error al procesar el pago.',
                    icon: 'error',
                    confirmButtonText: 'Ok'
                });
                this.isProcessing = false;
            }
        },
        async monitorTransactionStatus(transactionId) {
            try {
                // Define maximum attempts and interval (10 seconds between checks, max 30 attempts = 5 minutes)
                const maxAttempts = 30;
                let attempts = 0;

                // Start the polling interval
                const statusCheckInterval = setInterval(async () => {
                attempts++;
                    try {
                        const transaction = await this.$root.getTransaction(transactionId);
                        if (transaction.status === "ERROR") {
                            clearInterval(statusCheckInterval);
                            Swal.fire({
                                title: 'Error',
                                text: transaction.error.message,
                                icon: 'error',
                                confirmButtonText: 'Ok'
                            });
                            this.isProcessing = false;
                            return;
                        }
                        const type = this.formData.payment_method.type;
                        const transactionStatus = transaction.data.status;
                        const paramsTransferencia = {
                            json: JSON.stringify(this.order),
                            id_transaccion: transactionId
                        }
                        
                        // Handle different payment methods and their specific flows
                        if (type === 'BANCOLOMBIA_TRANSFER' || type === 'PSE') {
                            console.log('Redireccionando a:', transaction.data.payment_method.extra.async_payment_url);
                            if (transaction.data.payment_method.extra?.async_payment_url) {
                                clearInterval(statusCheckInterval);
                                this.$root.saveTransaccion(paramsTransferencia)
                                    .then(report => {
                                        if (report.status == "ERROR") {
                                            alert(report.error.message)
                                        } else {
                                            Swal.fire({
                                                title: 'Redirigiendo al banco...',
                                                text: 'Serás redirigido en unos segundos.',
                                                icon: 'info',
                                                allowOutsideClick: false,
                                                didOpen: () => {
                                                    Swal.showLoading();
                                                }
                                            });

                                            if (this.isRedirecting) return;
                                            this.isRedirecting = true;
                                            try {
                                                const redirectUrl = transaction.data.payment_method.extra?.async_payment_url;
                                                if (!redirectUrl || !/^https?:\/\//.test(redirectUrl)) {
                                                    console.error('URL inválida para redirección:', redirectUrl);
                                                    Swal.fire({
                                                        title: 'Error de redirección',
                                                        text: 'No se pudo obtener la URL de redirección al banco.',
                                                        icon: 'error',
                                                        confirmButtonText: 'Ok'
                                                    });
                                                    return;
                                                }
                                                window.open(redirectUrl, "_self");

                                            } catch (e) {
                                                console.error('Error al redirigir:', e);
                                            }
                                        }
                                    })
                                    .catch(err => {
                                        console.error('Error en saveTransaccion:', err);
                                    });
                                return;
                            }
                        }

                        // Process based on transaction status
                        if (transactionStatus === 'APPROVED') {
                            clearInterval(statusCheckInterval);                                
                            Swal.fire({
                            title: 'Pago Exitoso',
                            text: 'Su pago ha sido aprobado. Estamos procesando su orden...',
                            icon: 'success',
                            allowOutsideClick: false,
                            didOpen: () => {
                                Swal.showLoading();
                            }
                            });
                            // Create the order
                            await this.createOrderAndRedirect(transactionId);
                            
                        } else if (transactionStatus === 'DECLINED' || transactionStatus === 'ERROR' || transactionStatus === 'VOIDED') {
                            // Payment failed
                            clearInterval(statusCheckInterval);
                            Swal.fire({
                                title: 'Transacción Fallida',
                                text: `Estado de la transacción: ${transactionStatus}. Por favor intente con otro método de pago.`,
                                icon: 'error',
                                confirmButtonText: 'Ok'
                            });
                            this.isProcessing = false;
                            return;
                        }
                        // If we've reached max attempts, stop checking
                        if (attempts >= maxAttempts) {
                            clearInterval(statusCheckInterval);
                            Swal.fire({
                                title: 'Tiempo de espera excedido',
                                text: 'La verificación de su pago está tomando más tiempo del esperado. Puede verificar el estado de su orden más tarde.',
                                icon: 'warning',
                                confirmButtonText: 'Ok'
                            });
                            this.isProcessing = false;
                        }
                        
                    } catch (err) {
                        console.error('Error checking transaction status:', err);
                        // Continue checking despite error
                    }
                }, 10000); // Check every 10 seconds
            } catch (error) {
                console.error('Error monitoring transaction:', error);
                Swal.fire({
                title: 'Error',
                text: 'Ocurrió un error al verificar el estado de su transacción.',
                icon: 'error',
                confirmButtonText: 'Ok'
                });
                this.isProcessing = false;
            }
        },
        async createOrderAndRedirect(transactionId) {
            try {
            // Update order with transaction ID
            this.order.transactionId = transactionId;
            
            // Create the order
            const orderRes = await this.$root.post('orders/create', this.order);
            
            if (orderRes.status === "ERROR") {
                Swal.fire({
                title: 'Error',
                text: orderRes.error.message,
                icon: 'error',
                confirmButtonText: 'Ok'
                });
                this.isProcessing = false;
                return;
            }
            const voucherCode = orderRes.data.data.voucherCode[0];

            // Save order to localStorage
            //localStorage.setItem("order", JSON.stringify(this.order));
            
            // Close any open modals
            Swal.close();
            
            // Redirect to voucher page
            this.$router.push(`/voucher/${voucherCode}`);
            
            } catch (error) {
                console.error('Error creating order:', error);
                Swal.fire({
                    title: 'Error',
                    text: 'Ocurrió un error al procesar su orden. Por favor contacte a soporte.',
                    icon: 'error',
                    confirmButtonText: 'Ok'
                });
                this.isProcessing = false;
            }
        },
    }
  }
  </script>
  <style scoped>
  .modal-container {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 1rem;
  }
  
  .modal-content {
    background: white;
    padding: 1.5rem;
    border-radius: 8px;
    width: 100%;
    max-width: 600px;
    max-height: 90vh;
    overflow-y: auto;
  }
  
  .modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1.5rem;
  }
  
  .close-btn {
    background: none;
    border: none;
    font-size: 1.5rem;
    cursor: pointer;
    padding: 0.5rem;
  }
  
  .btn-zebra {
    background-color: #20c997;
    color: white;
  }
  
  .btn-zebra:hover {
    background-color: #17a2b8;
  }
  
  .form-label {
    font-weight: 500;
  }
  
  .text-zebra {
    color: #20c997;
    text-decoration: none;
  }
  
  .text-zebra:hover {
    text-decoration: underline;
  }
  
  .form-check-input:checked {
    background-color: #20c997;
    border-color: #20c997;
  }
  </style>